import React from 'react'
import PageHeader from '../components/PageHeader'

function FAQs() {
    return (
        <>
            <PageHeader title="Frequently asked questions" />

            <div className="page-faqs">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="faq-sidebar">
                                <div className="faq-catagery-list wow fadeInUp">
                                    <ul>
                                        <li>
                                            <a href="#online_cooperative_faq">
                                                Online Co-operative Platform
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#micro_lending_faq">
                                                Micro-Lending Services
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#tax_consulting_faq">
                                                Tax Consulting Services
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#financial_reporting_faq">
                                                Financial Reporting &amp;
                                                Analysis
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    className="sidebar-cta-box wow fadeInUp"
                                    data-wow-delay="0.25s"
                                >
                                    <div className="cta-box-content">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                                            alt=""
                                        />
                                        <h3>
                                            Need Help? We Are Here To Help You
                                        </h3>
                                    </div>
                                    <div className="cta-contact-info">
                                        <div className="cta-info-item">
                                            <p>Need help!</p>
                                            <h3>+234 705 803 0389</h3>
                                        </div>
                                        <div className="cta-info-item">
                                            <p>E-mail now</p>
                                            <h3>info@fidelanchor.com</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-8">
                            <div className="page-faqs-catagery">
                                {/* Online Co-operative Platform FAQs */}
                                <div
                                    className="page-faq-accordion"
                                    id="online_cooperative_faq"
                                >
                                    <div className="section-title">
                                        <h2
                                            className="text-anime-style-2"
                                            data-cursor="-opaque"
                                        >
                                            Online Co-operative Platform
                                        </h2>
                                    </div>
                                    <div
                                        className="faq-accordion"
                                        id="accordion"
                                    >
                                        <div className="accordion-item wow fadeInUp">
                                            <h2
                                                className="accordion-header"
                                                id="heading1"
                                            >
                                                <button
                                                    className="accordion-button"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapse1"
                                                    aria-expanded="true"
                                                    aria-controls="collapse1"
                                                >
                                                    Who can join the online
                                                    co-operative platform?
                                                </button>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className="accordion-collapse collapse show"
                                                aria-labelledby="heading1"
                                                data-bs-parent="#accordion"
                                            >
                                                <div className="accordion-body">
                                                    <p>
                                                        Any individual who is a
                                                        Nigerian resident aged
                                                        18 years or older can
                                                        sign up for our
                                                        platform. Businesses and
                                                        groups may also join as
                                                        corporate members,
                                                        provided they comply
                                                        with the Nigerian
                                                        Co-operative Societies
                                                        Act. Non-residents may
                                                        participate if they have
                                                        a valid Nigerian
                                                        identification or
                                                        business registration.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="accordion-item wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <h2
                                                className="accordion-header"
                                                id="heading2"
                                            >
                                                <button
                                                    className="accordion-button collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapse2"
                                                    aria-expanded="false"
                                                    aria-controls="collapse2"
                                                >
                                                    How do I register and choose
                                                    a co-operative branch?
                                                </button>
                                            </h2>
                                            <div
                                                id="collapse2"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="heading2"
                                                data-bs-parent="#accordion"
                                            >
                                                <div className="accordion-body">
                                                    <p>
                                                        Registration is free and
                                                        done online via our
                                                        website or app. You'll
                                                        need to provide your
                                                        National Identification
                                                        Number (NIN), Bank
                                                        Verification Number
                                                        (BVN), and proof of
                                                        address.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Micro-Lending Services FAQs */}
                                <div
                                    className="page-faq-accordion"
                                    id="micro_lending_faq"
                                >
                                    <div className="section-title">
                                        <h2
                                            className="text-anime-style-2"
                                            data-cursor="-opaque"
                                        >
                                            Micro-Lending Services
                                        </h2>
                                    </div>
                                    <div
                                        className="faq-accordion"
                                        id="accordion1"
                                    >
                                        <div className="accordion-item wow fadeInUp">
                                            <h2
                                                className="accordion-header"
                                                id="heading8"
                                            >
                                                <button
                                                    className="accordion-button"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapse8"
                                                    aria-expanded="false"
                                                    aria-controls="collapse8"
                                                >
                                                    What types of loans do you
                                                    offer?
                                                </button>
                                            </h2>
                                            <div
                                                id="collapse8"
                                                className="accordion-collapse collapse show"
                                                aria-labelledby="heading8"
                                                data-bs-parent="#accordion1"
                                            >
                                                <div className="accordion-body">
                                                    <p>
                                                        We provide individual
                                                        loans for personal needs
                                                        (₦50,000 to ₦1,000,000)
                                                        and business loans for
                                                        SMEs (up to ₦5,000,000),
                                                        with flexible terms
                                                        under CBN's microfinance
                                                        regulations.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Tax Consulting Services FAQs */}
                                <div
                                    className="page-faq-accordion"
                                    id="tax_consulting_faq"
                                >
                                    <div className="section-title">
                                        <h2
                                            className="text-anime-style-2"
                                            data-cursor="-opaque"
                                        >
                                            Tax Consulting Services
                                        </h2>
                                    </div>
                                    <div
                                        className="faq-accordion"
                                        id="accordion2"
                                    >
                                        <div className="accordion-item wow fadeInUp">
                                            <h2
                                                className="accordion-header"
                                                id="heading15"
                                            >
                                                <button
                                                    className="accordion-button"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapse15"
                                                    aria-expanded="true"
                                                    aria-controls="collapse15"
                                                >
                                                    What tax services do you
                                                    provide?
                                                </button>
                                            </h2>
                                            <div
                                                id="collapse15"
                                                className="accordion-collapse collapse show"
                                                aria-labelledby="heading15"
                                                data-bs-parent="#accordion2"
                                            >
                                                <div className="accordion-body">
                                                    <p>
                                                        We offer advisory on
                                                        personal and corporate
                                                        income tax, VAT,
                                                        transfer pricing, and
                                                        compliance filings,
                                                        using FIRS's e-Invoicing
                                                        platform for efficiency.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Financial Reporting FAQs */}
                                <div
                                    className="page-faq-accordion"
                                    id="financial_reporting_faq"
                                >
                                    <div className="section-title">
                                        <h2
                                            className="text-anime-style-2"
                                            data-cursor="-opaque"
                                        >
                                            Financial Reporting &amp; Analysis
                                        </h2>
                                    </div>
                                    <div
                                        className="faq-accordion"
                                        id="accordion3"
                                    >
                                        <div className="accordion-item wow fadeInUp">
                                            <h2
                                                className="accordion-header"
                                                id="heading22"
                                            >
                                                <button
                                                    className="accordion-button"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapse22"
                                                    aria-expanded="true"
                                                    aria-controls="collapse22"
                                                >
                                                    What standards do you follow
                                                    for reporting?
                                                </button>
                                            </h2>
                                            <div
                                                id="collapse22"
                                                className="accordion-collapse collapse show"
                                                aria-labelledby="heading22"
                                                data-bs-parent="#accordion3"
                                            >
                                                <div className="accordion-body">
                                                    <p>
                                                        We adhere to IFRS as
                                                        adopted in Nigeria,
                                                        including the 2025
                                                        roadmap for
                                                        Sustainability
                                                        Disclosure Standards by
                                                        the Financial Reporting
                                                        Council (FRC).
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FAQs
